import {
    SET_PUBLISHED_EVENTS,
    SET_EVENTS_QUESTION,
    SET_CURRENT_EVENT_ID,
    SET_QUESTIONS_DATA,
    SET_UPLOAD_SUCCESS_PENDING,
    SET_UPLOAD_RESPONSE,
    SET_CURRENT_EVENT_NAME,
    SET_TIMER_BOOLEAN,
    SET_ACTIVE_QUES_ID,
    SET_IS_GET_PUBLISHED_EVENT_PENDING,
    SET_IS_GET_QUESTIONS_LIST_PENDING,
    SET_IS_GET_QUESTION_DATA_PENDING,
    SET_IS_SUBMIT_ANSWER_PENDING,
    INIT_AUTOEVAL_DIALOG,
    SET_PROGRESS_VALUE,
    SET_PROGRESS_NAME,
    SET_AUTOEVAL_RESULT_STATUS,
    SET_AUTOEVAL_RESULT_STRING,
    LOAD_INPUTS,
    START_NEXT_INPUT,
    ANIMATE_STEP,
    STOP_ANIMATION,
    SET_USER_GAME_DATA,
    SET_CURRENT_EVAL_TYPE,
    SET_PLAY_GAME,
    SET_EXECUTE_PENDING,
    SET_EVENT_TYPE_GAME,
    SET_USER_TITLECARD_PENDING,
    SET_USER_TITLECARD,
    SET_IS_QUESTION_REDIRECT,
    SET_CURRENT_GAME_TYPE,
    SET_EXECUTE_USER_GAMEDATA,
    SET_CURRENT_GAME_TITLE,
    GET_GAMEUSER_DATA_PENDING,
    SET_EUTOEVAL_PROGRESS_STRING,
    SET_PROGRESS_CLOSE,
    SET_UPLOAD_ETA,
    IS_OPEN_MATCH_LIST
} from "../constants/events.constants";

const initialState: eventsState = {
    publishedEvents: [],
    currentEventId: null,
    questionData: {
        isUploadDisabled: false,
        isLocked: false
    },
    currentEventName: null,
    uploadPending: false,
    isTimerStarted: false,
    activeQuesId: null,
    isGetPublishedEventsPending: false,
    isGetQuestionsListPending: false,
    isGetQuestionDataPending: false,
    isSubmitAnswerPending: false,
    eventsQuestion: null,
    autoEvalDialogData: {
        progressValue: 0,
        currentProgressName: null,
        isTestcasesPassed: false,
        autoEvalResultString: null,
    },
    currentEvalType: 0,
    position: 0,
    gameInputs: [],
    inputIndex: 0,
    direction: null,
    remainingMove: 0,
    isAnimating: false,
    speed: 2,
    userGameData: null,
    playGame: false,
    userExecutePending: false,
    isEventGame: false,
    isUserTitleCardPending: false,
    userTitleCard: null,
    isQuestionRedirect: false,
    currentGameType: 0,
    userGameExecuteLog: null,
    currentGameTitle: "",
    getUserGameDataPending: false,
    autoEvalProgressString: "",
    evaluateWaitTimer: null,
    progressBarClose: false,
    uploadETATimer: null,
    isOpenMatchList: false,
};

export default (
    localState: eventsState = initialState,
    action: Action
): eventsState => {
    switch (action.type) {
        case INIT_AUTOEVAL_DIALOG: {
            return {
                ...localState,
                autoEvalDialogData: initialState.autoEvalDialogData,
            }
        }
        case SET_AUTOEVAL_RESULT_STATUS: {
            return {
                ...localState,
                autoEvalDialogData: {
                    ...localState.autoEvalDialogData,
                    isTestcasesPassed: action.payload
                }
            }
        }
        case SET_AUTOEVAL_RESULT_STRING: {
            return {
                ...localState,
                autoEvalDialogData: {
                    ...localState.autoEvalDialogData,
                    autoEvalResultString: action.payload
                }
            }
        }
        case SET_PROGRESS_VALUE: {
            return {
                ...localState,
                autoEvalDialogData: {
                    ...localState.autoEvalDialogData,
                    progressValue: action.payload
                }
            }
        }
        case SET_PROGRESS_NAME: {
            return {
                ...localState,
                autoEvalDialogData: {
                    ...localState.autoEvalDialogData,
                    currentProgressName: action.payload
                }
            }
        }
        case SET_PUBLISHED_EVENTS: {
            return {
                ...localState,
                publishedEvents: action.payload
            }
        }
        case SET_EVENTS_QUESTION: {
            return {
                ...localState,
                eventsQuestion: action.payload
            }
        }

        case SET_ACTIVE_QUES_ID: {
            return {
                ...localState,
                activeQuesId: action.payload
            }
        }

        case SET_CURRENT_EVENT_ID: {
            return {
                ...localState,
                currentEventId: action.payload
            }
        }
        case SET_QUESTIONS_DATA: {
            return {
                ...localState,
                questionData: action.payload
            }
        }
        case SET_UPLOAD_RESPONSE: {
            return {
                ...localState,
                uploadResponse: action.payload
            }
        }
        case SET_CURRENT_EVENT_NAME: {
            return {
                ...localState,
                currentEventName: action.payload
            }
        }
        case SET_UPLOAD_SUCCESS_PENDING: {
            return {
                ...localState,
                uploadPending: action.payload
            }
        }
        case SET_TIMER_BOOLEAN: {
            return {
                ...localState,
                isTimerStarted: action.payload
            }
        }
        case SET_IS_GET_PUBLISHED_EVENT_PENDING: {
            return {
                ...localState,
                isGetPublishedEventsPending: action.payload
            }
        }
        case SET_IS_GET_QUESTIONS_LIST_PENDING: {
            return {
                ...localState,
                isGetQuestionsListPending: action.payload
            }
        }
        case SET_IS_GET_QUESTION_DATA_PENDING: {
            return {
                ...localState,
                isGetQuestionDataPending: action.payload
            }
        }
        case SET_IS_SUBMIT_ANSWER_PENDING: {
            return {
                ...localState,
                isSubmitAnswerPending: action.payload
            }
        }
        case LOAD_INPUTS:
            return {
                ...localState,
                gameInputs: action.payload,
                inputIndex: 0
            };

        case START_NEXT_INPUT: {
            if (localState.inputIndex >= localState.gameInputs.length) return localState;

            const input = localState.gameInputs[localState.inputIndex];

            return {
                ...localState,
                direction: input.direction,
                remainingMove: input.value,
                isAnimating: true
            };
        }

        case ANIMATE_STEP: {
            // 1️⃣ Stop current command when finished
            if (localState.remainingMove <= 0) {
                return {
                    ...localState,
                    isAnimating: false,
                    inputIndex: localState.inputIndex + 1,
                    remainingMove: 0
                };
            }

            // 2️⃣ Validate required values
            const position =
                typeof localState.position === "number"
                    ? localState.position
                    : 0;

            const speed =
                typeof localState.speed === "number" && localState.speed > 0
                    ? localState.speed
                    : 1;

            const remainingMove =
                typeof localState.remainingMove === "number"
                    ? localState.remainingMove
                    : 0;

            const direction =
                localState.direction === "left" || localState.direction === "right"
                    ? localState.direction
                    : "right";

            // 3️⃣ Calculate safe step
            const step = Math.min(speed, remainingMove);
            const delta = direction === "right" ? step : -step;

            // 4️⃣ Apply movement
            return {
                ...localState,
                position: position + delta,
                remainingMove: remainingMove - step
            };
        }

        case STOP_ANIMATION:
            return {
                ...localState,
                isAnimating: false
            };
        case SET_USER_GAME_DATA: {
            return {
                ...localState,
                userGameData: action.payload
            }
        }
        case SET_CURRENT_EVAL_TYPE: {
            return {
                ...localState,
                currentEvalType: action.payload
            }
        }
        case SET_PLAY_GAME: {
            return {
                ...localState,
                playGame: action.payload
            }
        }
        case SET_EXECUTE_PENDING: {
            return {
                ...localState,
                userExecutePending: action.payload
            }
        }
        case SET_EVENT_TYPE_GAME: {
            return{
                ...localState,
                isEventGame: action.payload
            }
        }
        case SET_USER_TITLECARD_PENDING: {
            return {
                ...localState,
                isUserTitleCardPending: action.payload
            }
        }
        case SET_USER_TITLECARD: {
            return {
                ...localState,
                userTitleCard: action.payload
            }
        }
        case SET_IS_QUESTION_REDIRECT: {
            return {
                ...localState,
                isQuestionRedirect: action.payload
            }
        }
        case SET_CURRENT_GAME_TYPE: {
            return{
                ...localState,
                currentGameType: action.payload
            }
        }
        case SET_EXECUTE_USER_GAMEDATA: {
            return {
                ...localState,
                userGameExecuteLog: action.payload
            }
        }
        case SET_CURRENT_GAME_TITLE: {
            return {
                ...localState,
                currentGameTitle: action.payload
            }
        }
        case GET_GAMEUSER_DATA_PENDING:{
            return {
                ...localState,
                getUserGameDataPending: action.payload
            }
        }
        case SET_EUTOEVAL_PROGRESS_STRING: {
            return {
                ...localState,
                autoEvalDialogData: {
                    ...localState.autoEvalDialogData,
                    autoEvalProgressString: action.payload
                }
            }
        }
        case SET_PROGRESS_CLOSE: {
            return {
                ...localState,
                progressBarClose: action.payload
            }
        }
        case SET_UPLOAD_ETA: {
            return {
                ...localState,
                uploadETATimer: action.payload
            }
        }
        case IS_OPEN_MATCH_LIST: {
            return {
                ...localState,
                isOpenMatchList: action.payload
            }
        }
        default: {
            return localState;
        }
    }
}